import { useConferenceInstance, IConference } from '@containers/Conference';
import * as utils from './utils';
import { ColorRing } from './ColorRing';
import styles from './style/WaitingRoom.css';

export function WaitingRoom() {
  const instance = useConferenceInstance<IConference.Coordinator.Conference.WaitingRoom>();

  const text = instance.waitingType === 'for-start'
    ? 'Waiting for host to start the conference.'
    : 'Waiting for host to let you in!';

  return (
    <div className={styles.root}>
      <div className={styles.wrap}>
        <div className={styles.title}>{`${instance.conference.title} Call`}</div>
        <div className={styles.date}>
          {utils.formatCallTime(instance.call.start, instance.call.end)}
        </div>
        <div className={styles.text}>{text}</div>
        <ColorRing size={35} />
      </div>
    </div>
  );
}